if (!customElements.get('bundle-manager')) {
  class BundleManager extends HTMLElement {
    constructor() {
      super();
      this.bundle = [];
      this.maxBundleSize = Number(this.dataset.maxSizeBdl);
      
      this.productList = this.querySelector("#product-list");
      this.bundleList = this.querySelector("#bundle-items");
      this.bundleTotal = this.querySelector("#bundle-total");
      this.addToCartBtn = this.querySelector(".bundle-list-footer .add-to-cart");
      this.itemRange = this.querySelector("#item-range");

      this.strings = {
        remove: this.dataset.textRemove,
        added: this.dataset.textAdded,
        adding: this.dataset.textAdding,
        addToBundle: this.dataset.textAddToBundle,
        bundleFull: this.dataset.textBundleFull,
        bundleFullAlert: this.dataset.textBundleFullAlert,
        chooseVariant: this.dataset.textChooseVariant,
        unavailable: this.dataset.textUnavailable,
        soldOut: this.dataset.textSoldOut,
        selectVariantAlert: this.dataset.textSelectVariantAlert,
        failedAdd: this.dataset.textFailedAdd
      };

      this.currencySymbol = this.dataset.currencySymbol || '৳';
      this.moneyFormat = this.dataset.moneyFormat || "${{amount}}";
      this.init();
    }

    init() {
      this.initProductButtons();
      this.updateUI();
      this.updateAllButtons();

      this.colasIcon = this.querySelector(".bundle-list-header-icon");
      this.colasIcon.addEventListener("click", () => this.toggleBundleList());
    }

    toggleBundleList() {
      this.colasIcon.classList.toggle("active-cion");
      this.bundleList.classList.toggle("active");
    }

    initProductButtons() {
      this.querySelectorAll(".product").forEach(product => {
        const button = product.querySelector(".product-btn");
        const variantInput = product.querySelector(".product-variant-id");

        product.querySelectorAll("input[type='radio']").forEach(radio => {
          radio.addEventListener("change", () => this.validateProductSelection(product));
        });

        this.validateProductSelection(product);

        if (button) {
          button.addEventListener("click", () => {
            const title = product.dataset.title;
            const contextImage = product.dataset.image;
            const variantsJsonScript = product.querySelector(".product-variants-json");
            let productVariants = [];
            try {
                if (variantsJsonScript) productVariants = JSON.parse(variantsJsonScript.textContent);
            } catch(e) {}

            let price = 0;
            let image = contextImage; 
            if (productVariants.length > 0 && variantInput.value) {
                const selectedVar = productVariants.find(v => v.id == variantInput.value);
                if (selectedVar) {
                   price = selectedVar.price / 100;
                   if(selectedVar.featured_image && selectedVar.featured_image.src) {
                       image = selectedVar.featured_image.src;
                   }
                } 
            } else {
                 const priceItem = product.querySelector(".price-item--sale") || product.querySelector(".price-item--regular");
                 price = priceItem ? this.parsePrice(priceItem.innerText) : 0;
            }
            

            const rawOptions = [];
            product.querySelectorAll(".variant-group").forEach(group => {
                const name = group.querySelector(".variant-group-name")?.innerText || "";
                const value = group.querySelector("input:checked")?.value;
                if (name && value) {
                    rawOptions.push(`${name}: ${value}`);
                }
            });
            const options = rawOptions.join(" / ");
            
            const variantId = variantInput?.value;

            if (!variantId) {
              alert(this.strings.selectVariantAlert);
              return;
            }

            this.addToBundle({
              title,
              price,
              variantId,
              image,
              options
            });
          });
        }
      });

      this.addToCartBtn.addEventListener("click", () => this.addBundleToCart());
    }

    validateProductSelection(product) {
        const button = product.querySelector(".product-btn");
        const variantInput = product.querySelector(".product-variant-id");
        
        if (!variantInput) return; 

        const variantGroups = product.querySelectorAll(".variant-group");
        const variantsJsonScript = product.querySelector(".product-variants-json");
        
        let productVariants = [];
        try {
          if (variantsJsonScript) {
            productVariants = JSON.parse(variantsJsonScript.textContent);
          }
        } catch (e) {
          console.error("Error parsing variants JSON", e);
        }


        if (variantGroups.length === 0) {
            const variantId = variantInput.value;
            const matchedVariant = productVariants.find(v => v.id == variantId);
            
            if (matchedVariant) {
                 this.updateProductPrice(product, matchedVariant);

                 if (matchedVariant.available) {
                     this.updateButtonStateForProduct(product, button, matchedVariant.id, "AVAILABLE");
                 } else {
                     this.updateButtonStateForProduct(product, button, matchedVariant.id, "SOLDOUT");
                 }
            } else {

                 this.updateButtonStateForProduct(product, button, variantId, "AVAILABLE");
            }
            return;
        }

        const selectedOptions = [];
        let allSelected = true;

        variantGroups.forEach(group => {
            const checked = group.querySelector("input:checked");
            if (checked) {
                selectedOptions.push(checked.value);
            } else {
                allSelected = false;
            }
        });

        if (!allSelected) {
            this.updateButtonStateForProduct(product, button, null, "INCOMPLETE");
            return;
        }

       
        const matchedVariant = productVariants.find(variant => {
            return variant.options.every((opt, index) => opt === selectedOptions[index]);
        });

        if (matchedVariant) {
            this.updateProductPrice(product, matchedVariant);

            if (matchedVariant.available) {
                variantInput.value = matchedVariant.id;
                this.updateButtonStateForProduct(product, button, matchedVariant.id, "AVAILABLE");
            } else {
                this.updateButtonStateForProduct(product, button, matchedVariant.id, "SOLDOUT");
            }
        } else {
            this.updateButtonStateForProduct(product, button, null, "UNAVAILABLE");
        }
    }

   
    updateProductPrice(product, variant) {
        const priceWrapper = product.querySelector(".price");
        if (!priceWrapper) return;

        const regularPriceItem = priceWrapper.querySelector(".price__regular .price-item--regular");
        const salePriceItem = priceWrapper.querySelector(".price__sale .price-item--sale");
        const comparePriceItem = priceWrapper.querySelector(".price__sale .price-item--regular"); // Strikethrough
        const compareAtPrice = variant.compare_at_price;
        const onSale = variant.compare_at_price > variant.price;

        if (onSale) {
            priceWrapper.classList.add("price--on-sale");
            if (salePriceItem) salePriceItem.innerHTML = this.formatMoney(variant.price, this.moneyFormat);
            if (comparePriceItem && compareAtPrice) comparePriceItem.innerHTML = this.formatMoney(variant.compare_at_price, this.moneyFormat);
        } else {
            priceWrapper.classList.remove("price--on-sale");
            if (regularPriceItem) regularPriceItem.innerHTML = this.formatMoney(variant.price, this.moneyFormat);
        }
    }

    formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || this.moneyFormat;

      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        const parts   = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    updateButtonStateForProduct(product, button, variantId, status) {
        
        
        if (!button) return;

        
        if (this.bundle.length >= this.maxBundleSize) {
            button.disabled = true;
            button.innerText = this.strings.bundleFull;
            return;
        }

       
        if (status === "INCOMPLETE") {
            button.disabled = true;
            button.innerText = this.strings.chooseVariant;
            return;
        }
        if (status === "UNAVAILABLE") {
            button.disabled = true;
            button.innerText = this.strings.unavailable;
            return;
        }
        if (status === "SOLDOUT") {
            button.disabled = true;
            button.innerText = this.strings.soldOut;
            return;
        }

        
        if (status === "AVAILABLE") {
             const isInBundle = this.bundle.some(item => item.variantId == variantId);
             if (isInBundle) {
                 button.disabled = true;
                 button.innerText = this.strings.added;
             } else {
                 button.disabled = false;
                 button.innerText = this.strings.addToBundle;
             }
        }
    }

   
    updateAllButtons() {
        this.querySelectorAll(".product").forEach(product => {
            this.validateProductSelection(product);
        });
    }

   
    addToBundle(item) {
      if (this.bundle.length >= this.maxBundleSize) {
          alert(this.strings.bundleFullAlert);
          return;
      }
      this.bundle.push(item);
      this.renderBundle();
      this.updateUI();
      this.updateAllButtons();
    }

 
    removeFromBundle(index) {
      this.bundle.splice(index, 1);
      this.renderBundle();
      this.updateUI();
      this.updateAllButtons();
    }

   
    renderBundle() {
      this.bundleList.innerHTML = "";

      if (this.bundle.length === 0) {
        this.bundleList.innerHTML = this.getPlaceholders();
        return;
      }

      this.bundle.forEach((item, index) => {
        const li = document.createElement("li");
        li.className = "flex align-items-center";
        
        let imageHtml = `<div class="item-thumb no-item-thumb"></div>`;
        if (item.image && item.image !== "null" && item.image !== "") { 
            imageHtml = `<div class="item-thumb"><img src="${item.image}" alt="${item.title}"></div>`;
        }

        li.innerHTML = `
          ${imageHtml}
          <div class="item-product-info">
            <strong>${item.title}</strong>
           
            <span>${this.currencySymbol}${item.price.toFixed(2)}</span>
          </div>
          <button class="remove-item" data-index="${index}">${this.strings.remove}</button>
        `;

        li.querySelector(".remove-item").addEventListener("click", () => {
          this.removeFromBundle(index);
        });

        this.bundleList.appendChild(li);
      });
    }

    
    updateUI() {
      const count = this.bundle.length;

      this.addToCartBtn.disabled = count === 0;

      const progress = Math.min((count / this.maxBundleSize) * 100, 100);
      
      this.itemRange.style.setProperty("--item-range", `${progress}%`);

      const total = this.bundle.reduce((sum, i) => sum + i.price, 0);

      this.bundleTotal.innerText = `${this.currencySymbol}${total.toFixed(2)}`;
    }


    async addBundleToCart() {
      if (this.bundle.length === 0) return;

      const originalText = this.addToCartBtn.innerText;
      this.addToCartBtn.innerText = this.strings.adding;
      this.addToCartBtn.disabled = true;

      const items = this.bundle.map(item => ({
        id: item.variantId,
        quantity: 1
      }));

      try {


        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            items,
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: window.location.pathname
          })
        });

        const responseJson = await response.json();


        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            cartDrawer.renderContents(responseJson);
        }




        this.addToCartBtn.innerText = this.strings.added;
        

        this.bundle = [];
        this.renderBundle();
        this.updateUI();
        this.updateAllButtons();

        setTimeout(() => {
            this.addToCartBtn.innerText = originalText;
            this.addToCartBtn.disabled = false;
        }, 2000);

      } catch (err) {
        alert(this.strings.failedAdd);
        console.error(err);
        this.addToCartBtn.innerText = originalText;
        this.addToCartBtn.disabled = false;
      }
    }


    parsePrice(text) {
      return parseFloat(text.replace(/[^\d.]/g, "")) || 0;
    }

    getPlaceholders() {
      return `
        <li class="flex align-items-center">
          <div class="item-thumb placeholder"><span class="activity"></span></div>
          <div class="item-product-info">
            <div class="placeholder"><span class="activity"></span></div>
            <div class="placeholder"><span class="activity"></span></div>
          </div>
        </li>
        <li class="flex align-items-center">
          <div class="item-thumb placeholder"><span class="activity"></span></div>
          <div class="item-product-info">
            <div class="placeholder"><span class="activity"></span></div>
            <div class="placeholder"><span class="activity"></span></div>
          </div>
        </li>
        <li class="flex align-items-center">
          <div class="item-thumb placeholder"><span class="activity"></span></div>
          <div class="item-product-info">
            <div class="placeholder"><span class="activity"></span></div>
            <div class="placeholder"><span class="activity"></span></div>
          </div>
        </li>
      `;
    }
  }

  customElements.define("bundle-manager", BundleManager);
}
